/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShopifyAppStoredSessionDto } from '../../models/shopify-app-stored-session-dto';
import { UpsertShopifyAppSessionDto } from '../../models/upsert-shopify-app-session-dto';

export interface ShopifyAppControllerUpsertSession$Params {
  shopifySessionId: string;

  /**
   * Store identifier for multi-tenant requests.
   */
  'terrific-store-id'?: string;
  body: UpsertShopifyAppSessionDto;
}

export function shopifyAppControllerUpsertSession(
  http: HttpClient,
  rootUrl: string,
  params: ShopifyAppControllerUpsertSession$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<ShopifyAppStoredSessionDto>> {
  const rb = new RequestBuilder(rootUrl, shopifyAppControllerUpsertSession.PATH, 'put');
  if (params) {
    rb.path('shopifySessionId', params.shopifySessionId, {});
    rb.header('terrific-store-id', params['terrific-store-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopifyAppStoredSessionDto>;
    })
  );
}

shopifyAppControllerUpsertSession.PATH = '/api/v1/shopify-app/sessions/{shopifySessionId}';
